import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'course_page',
  components: {
    authorTable: function authorTable() {
      return import('../edu_liyou_author_sel');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '课程',
        addFunName: 'eduLiyouCoureseAdd',
        modifyFunName: 'eduLiyouCoureseModify',
        delFunName: 'eduLiyouCoureseDel',
        queryFunName: 'eduLiyouCoureseQuery',
        detailFunName: 'eduLiyouCoureseDetail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        unOnlineFunName: 'eduLiyouCoureseUnOnline',
        onlineFunName: 'eduLiyouCoureseOnline',
        recommendFunName: 'eduLiyouCoureseRecommend',
        unRecommendFunName: 'eduLiyouCoureseUnRecommend',
        lecturerDetailFunName: 'eduLiyouLecturerDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        title: null,
        type: null,
        remark: null,
        category: null,
        courseCost: null,
        commissionScale: null,
        cover: null,
        topBackgroundImage: null,
        musicBackgroundImage: null,
        freeRecommendAmount: null,
        groupQrcode: null,
        onlineState: null,
        lecturerId: null
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '课程类型不能为空',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '课程类别不能为空',
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: '课程简介不能为空',
          trigger: 'blur'
        }],
        lecturerId: [{
          required: true,
          message: '请选择课程讲师',
          trigger: 'blur'
        }],
        courseCost: [{
          required: true,
          message: '课程价格不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '课程价格必须为有效金额',
          trigger: 'blur'
        }],
        commissionScale: [{
          required: true,
          message: '返佣比例不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '返佣比例必须为有效数值',
          trigger: 'blur'
        }],
        cover: [{
          required: true,
          message: '封面不能为空',
          trigger: 'blur'
        }],
        topBackgroundImage: [{
          required: true,
          message: '顶部背景不能为空',
          trigger: 'blur'
        }],
        musicBackgroundImage: [{
          required: true,
          message: '音频背景不能为空',
          trigger: 'blur'
        }],
        groupQrcode: [{
          required: true,
          message: '群二维码不能为空',
          trigger: 'blur'
        }],
        freeRecommendAmount: [{
          required: true,
          message: '免费需推荐人数不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(?:[1-9]\d*)$/,
          message: '免费需推荐人数必须大于等于1',
          trigger: 'blur'
        }],
        onlineState: [{
          required: true,
          message: '请选择上架状态',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      formLabelWidthPlus: '120px',
      emptyFormData: {},
      dicData: {
        upperCode: 'liyou_course_category',
        configCourseTypes: [],
        configCourseTypeOptions: {},
        configCourseTypeOptionsFirst: {}
      },
      secondCategory: [],
      secondCategoryOptions: {},
      lecturer: {},
      selShow: false
    };
  },
  watch: {
    // formData: {
    //   handler(valNew) {
    //     if (valNew.type === 'Advanced') {
    //       this.formData.freeRecommendAmount = -1
    //     }
    //     if (valNew.type === 'Basics') {
    //       this.formData.freeRecommendAmount = 0
    //     }
    //   }
    //   , deep: true
    // }
    'formData.type': {
      handler: function handler(to) {
        if (to === 'Basics') {
          this.formData.freeRecommendAmount = 1;
        } else if (to === 'Advanced') {
          this.formData.freeRecommendAmount = -1;
        }
      },
      deep: true
    },
    'formData.category': {
      handler: function handler(to) {
        var _this = this;
        if (!to) {
          this.secondCategory = [];
          this.formData.secondCategory = '';
        } else {
          this.$api[this.pageConfig.dicTreeFunName](this.formData.category).then(function (res) {
            if (res.data) {
              _this.secondCategory = res.data;
              for (var i = 0; i < res.data.length; i++) {
                _this.secondCategoryOptions[res.data[i].code] = res.data[i].name;
              }
            }
          });
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this2.$api[_this2.pageConfig.dicTreeFunName](_this2.dicData.upperCode).then(function (res) {
        if (res.data) {
          _this2.dicData.configCourseTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this2.dicData.configCourseTypeOptions[res.data[i].code] = res.data[i].name;
            _this2.dicData.configCourseTypeOptionsFirst[res.data[i].code] = res.data[i];
            var obj = {};
            var _iterator = _createForOfIteratorHelper(res.data[i].lowerDics),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;
                obj[item.code] = item.name;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _this2.dicData.configCourseTypeOptionsFirst[res.data[i].code].lower = obj;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this2.query();
      console.log('this.dicData.configCourseTypeOptionsFirst', _this2.dicData.configCourseTypeOptionsFirst);
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'class':
          // 课时列表
          this.goChild(command.row, 'courseClass');
          break;
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'unOnline':
          // 下架
          this.unOnline(command.row.id);
          break;
        case 'online':
          // 上架
          this.online(command.row.id);
          break;
        case 'recommend':
          // 推荐
          this.recommend(command.row);
          break;
        case 'unRecommend':
          // 取消推荐
          this.unRecommend(command.row.id);
          break;
      }
    },
    goChild: function goChild(course, tableName) {
      this.$emit('child-go', course, tableName);
    },
    selectAuthor: function selectAuthor(val) {
      if (val) {
        this.lecturer = val;
        this.formData.lecturerId = val.id;
      }
      this.selShow = false;
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      paramData.commissionScale = Number(paramData.commissionScale) * 100 || 0;
      paramData.courseCost = Number(paramData.courseCost) / 100 || 0;
      if (!paramData.lecturerId) {
        this.lecturer = {};
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      saveFormData.commissionScale = Number(saveFormData.commissionScale) / 100 || 0;
      saveFormData.courseCost = Number(saveFormData.courseCost) * 100 || 0;
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadCoverImage: function uploadCoverImage(_ref) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this3.formData.cover = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadTopBackgroundImage: function uploadTopBackgroundImage(_ref3) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.topBackgroundImage = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    uploadMusicBackgroundImage: function uploadMusicBackgroundImage(_ref5) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref5.file;
              _this5.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this5.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this5.formData.musicBackgroundImage = _context5.sent;
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    uploadGroupQrcode: function uploadGroupQrcode(_ref7) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref7.file;
              _this6.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this6.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this6.formData.groupQrcode = _context7.sent;
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    removeCoverImage: function removeCoverImage() {
      this.formData.cover = '';
    },
    removeTopBackgroundImage: function removeTopBackgroundImage() {
      this.formData.topBackgroundImage = '';
    },
    removeMusicBackgroundImage: function removeMusicBackgroundImage() {
      this.formData.musicBackgroundImage = '';
    },
    removeGroupQrcode: function removeGroupQrcode() {
      this.formData.groupQrcode = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this7 = this;
      this.$api.eduLiyouCoureseDetail(id).then( /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(res) {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this7.initFormData(res.data);
              case 2:
                if (res.data.type === 'Basics') {
                  _this7.$set(_this7.formData, 'freeRecommendAmount', res.data.freeRecommendAmount);
                }
                if (res.data.lecturerId) {
                  _this7.getLecturer(res.data.lecturerId);
                }
                _this7.editDialogTitle = _this7.pageConfig.editPageName + '维护';
                _this7.editDialogShow = true;
              case 6:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x5) {
          return _ref9.apply(this, arguments);
        };
      }());
    },
    getLecturer: function getLecturer(lecturerId) {
      var _this8 = this;
      this.$api[this.pageConfig.lecturerDetailFunName](lecturerId).then( /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(res) {
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _this8.lecturer = res.data || {};
              case 1:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        return function (_x6) {
          return _ref10.apply(this, arguments);
        };
      }());
    },
    del: function del(id) {
      var _this9 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this9.$api[_this9.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this9.$message.success('删除成功');
            _this9.query();
          } else {
            _this9.$message.error('删除失败');
          }
        });
      });
    },
    unOnline: function unOnline(id) {
      var _this10 = this;
      this.$api[this.pageConfig.unOnlineFunName](id).then(function (res) {
        if (res.data) {
          _this10.$message.success('下架成功');
          _this10.query();
        } else {
          _this10.$message.error('下架失败');
        }
      });
    },
    online: function online(id) {
      var _this11 = this;
      this.$api[this.pageConfig.onlineFunName](id).then(function (res) {
        if (res.data) {
          _this11.$message.success('上架成功');
          _this11.query();
        } else {
          _this11.$message.error('上架失败');
        }
      });
    },
    recommend: function recommend(row) {
      var _this12 = this;
      this.$prompt('请输入推荐排序号', "\u300A".concat(row.title, "\u300B\u63A8\u8350\u5230\u9996\u9875"), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[1-9]\d*$/,
        inputErrorMessage: '排序号必须为正整数'
      }).then(function (_ref11) {
        var value = _ref11.value;
        _this12.$api[_this12.pageConfig.recommendFunName](row.id, value).then(function (res) {
          _this12.$message.success('操作成功');
          _this12.query();
        });
      }).catch(function () {});
    },
    unRecommend: function unRecommend(id) {
      var _this13 = this;
      this.$api[this.pageConfig.unRecommendFunName](id).then(function (res) {
        if (res.data) {
          _this13.$message.success('取消成功');
          _this13.query();
        } else {
          _this13.$message.error('取消失败');
        }
      });
    },
    query: function query() {
      var _this14 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this14.tableData = res.data || [];
        _this14.totalCount = res.count;
        _this14.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this15 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this15.formData.id) {
            // 编辑
            _this15.$api[_this15.pageConfig.modifyFunName](_this15.saveFormDataProcess(_this15.formData)).then(function (res) {
              if (res.data) {
                _this15.$message.success('编辑成功');
                _this15.initFormData(_this15.emptyFormData);
                _this15.editDialogShow = false;
                _this15.query();
              } else {
                _this15.$message.error('编辑失败');
              }
            });
          } else {
            // 新增
            _this15.$api[_this15.pageConfig.addFunName](_this15.saveFormDataProcess(_this15.formData)).then(function (res) {
              if (res.data) {
                _this15.$message.success('新增成功');
                _this15.initFormData(_this15.emptyFormData);
                _this15.editDialogShow = false;
                _this15.query();
              } else {
                _this15.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};